import { Moment } from 'moment';
import { OpeningHoursInterface } from '../../services/exports/Interfaces';
import { useCallback } from 'react';
import collect, { Collection } from 'collect.js';

const useWorkSchedule = () => {
  const getWorkScheduleDate = useCallback(
    (workSchedule: OpeningHoursInterface[], date: Moment): { start: Moment; end: Moment }[] => {
      const day = date.day();
      const schedule = findWorkSchedule(workSchedule, day);

      if (schedule.isEmpty()) {
        return [];
      }

      const result: { start: Moment; end: Moment }[] = [];

      schedule.each((entry) => {
        if (!entry.open || !entry.close) return;

        const startDate = date.clone().hour(entry.open.hour).minute(entry.open.minute).second(0).millisecond(0);

        const closeDay = entry.close.day;
        const openDay = entry.open.day;

        const closeDayOffset = closeDay >= openDay ? closeDay - openDay : closeDay + 7 - openDay;

        const endDate = startDate
          .clone()
          .add(closeDayOffset, 'days')
          .hour(entry.close.hour)
          .minute(entry.close.minute)
          .second(0)
          .millisecond(0);

        result.push({ start: startDate, end: endDate });
      });

      return result;
    },
    [],
  );

  const findWorkSchedule = (workSchedule: OpeningHoursInterface[], day: number): Collection<OpeningHoursInterface> =>
    collect(workSchedule).where('open.day', day);

  return { getWorkScheduleDate };
};

export default useWorkSchedule;
